/** @format */

import QuoteStep from "../enums/QuoteStep";
import useQuoteStore from "../store/QuoteStore";
import useAppStateStore from "../../../shared/store/AppStateStore";
import { handleNext } from "../../../shared/utils/navigationUtils";
import ModalWrapper from "../../../shared/components/ModalWrapper";
import Button from "../../../shared/components/Button";

const UberDetailsConfirmationModal = ({ onClose }) => {
  const STATE = useAppStateStore();
  const { updateField } = useQuoteStore.getState();
  const quoteStore = useQuoteStore.getState();
  const driver = quoteStore?.quote?.risk?.drivers[0];
  const vehicles = quoteStore?.quote?.risk?.vehicles;
  const isValidVehicleOnNewQuote = STATE.isValidVehicleOnNewQuote;
  const isValidAddressOnNewQuote = STATE.isValidAddressOnNewQuote;

  const handleYesClick = () => {
    STATE.setHideTq2Questions(true);
    updateField("risk.drivers.0.datePassedTest", "2008-01-01T00:00:00");
    if (
      (isValidVehicleOnNewQuote === true &&
        isValidAddressOnNewQuote === true &&
        driver.address) ||
      (isValidVehicleOnNewQuote === false &&
        isValidAddressOnNewQuote === true &&
        driver.address)
    ) {
      handleNext(QuoteStep.TQ3, STATE);
    } else if (
      isValidVehicleOnNewQuote === true &&
      isValidAddressOnNewQuote === false
    ) {
      handleNext(QuoteStep.TQ2, STATE);
    } else {
      handleNext(QuoteStep.TQ1, STATE);
    }
    STATE.setQuoteCall(true);
    onClose();
  };

  const handleEditClick = () => {
    if (!isValidVehicleOnNewQuote || !isValidAddressOnNewQuote) {
      handleNext(QuoteStep.TQ1, STATE);
    }
    STATE.setHideTq2Questions(false);
    updateField("risk.drivers.0.datePassedTest", null);
    STATE.setQuoteCall(true);
    onClose();
  };

  return (
    <>
      {driver.forename && (
        <ModalWrapper
          heading="Your Information"
          size="large"
          onClose={() => setModalOpen(false)}
          showClose={false}
        >
          <div className="tw-text-base tw-leading-[1.5]">
            <div className="tw-mb-2.5 tw-text-base tw-text-dis-text-2">
              {[
                {
                  label: "Name",
                  value: `${driver.forename} ${driver.surname}`,
                },
                { label: "Email", value: driver.emailAddress },
                { label: "Telephone", value: driver.telephone },
                {
                  label: "Date of birth",
                  value: driver.dateOfBirth
                    .split("T")[0]
                    .split("-")
                    .reverse()
                    .join("/"),
                },
                {
                  label: "Licence number",
                  value: driver.licenceNumber
                    ? `${driver.licenceNumber.slice(
                        0,
                        11
                      )} - ${driver.licenceNumber.slice(11)}`
                    : "",
                },
                {
                  label: "Home address",
                  value:
                    [
                      driver.address?.houseNo,
                      driver.address?.street,
                      driver.address?.city,
                      driver.address?.postcode,
                    ]
                      .filter(Boolean)
                      .join(", ") || "Not provided by Uber",
                },
                {
                  label: "Uber Pro rating",
                  value: driver.uberDriverRatingId,
                },
                {
                  label: "Registration number",
                  value: vehicles[0]?.licensingPlateNumber,
                },
                {
                  label: "Occupation",
                  value:
                    driver.occupations?.[0]?.occupationDescription ||
                    "Uber Driver",
                },
                {
                  label: "Business",
                  value: "Taxi Service",
                },
                {
                  label: "Employee status",
                  value: "Self Employed",
                },
              ]
                .filter(Boolean)
                .map((item) => (
                  <div
                    key={item.label}
                    className="tw-grid tw-grid-cols-[minmax(0,0.8fr)_minmax(0,1.6fr)] tw-gap-4 tw-border-x-0 tw-border-t-0 tw-border-b tw-border-solid tw-border-dis-border tw-py-3 max-[400px]:tw-grid-cols-1 max-[400px]:tw-gap-1"
                  >
                    <strong className="tw-text-dis-navy">{item.label}</strong>
                    <span className="tw-break-words">{item.value || "—"}</span>
                  </div>
                ))}
            </div>
            <div className="tw-mt-5">
              <p className="tw-m-0 tw-mb-3 tw-text-base tw-font-semibold tw-text-dis-navy">
                Is this information correct?
              </p>
              <div className="tw-flex tw-justify-end tw-gap-3 max-[480px]:tw-flex-col">
                <Button
                  type="button"
                  variant="soft"
                  size="small"
                  onClick={handleEditClick}
                  className="max-[480px]:tw-w-full"
                >
                  Edit
                </Button>
                <Button
                  type="button"
                  variant="main"
                  size="small"
                  onClick={handleYesClick}
                  className="max-[480px]:tw-w-full"
                >
                  Yes
                </Button>
              </div>
            </div>
          </div>
        </ModalWrapper>
      )}
    </>
  );
};

export default UberDetailsConfirmationModal;
